import * as React from 'react'
import { Modal } from '../../../Components/Modal';
import '../Adminbookings.css';
import { toast } from 'react-toastify';
import { AdminIcon } from '../../../Icons/AdminIcon';
import { format } from "date-fns";
import { AdminTimeSlot } from '../AdminBookings';
import { BookingDto } from '../../../Types/BookingServiceTypes';
import { DataService } from '../../../DataService/DataService';
interface IRescheduleModal{
    handleModal:(key:'delete'|'reschedule'|'send_material'|'submit-new-timeslots'|'remove-timeslots'|'put-notes') => void;
    avilableSlots:AdminTimeSlot[];
    selectedBooking:BookingDto;
}
export const RescheduleModal = ({handleModal,avilableSlots,selectedBooking}:IRescheduleModal) => {
    console.log(avilableSlots)
        const [timeSlots, setTimeSlots] = React.useState<AdminTimeSlot[]>([]);
        const [newTimeSlot, setNewTimeSlot] = React.useState("");
      const [selectedDate, setSelectedDate] = React.useState<Date | undefined>(new Date());
      const addTimeSlots = () => {
        
        if (selectedDate && newTimeSlot) {
          const nextId = timeSlots.length > 0
            ? Math.max(...timeSlots.map((slot) => slot.id)) + 1
            : 1;
          const newSlot: AdminTimeSlot = {
            id: nextId,
            date: format(selectedDate, "yyyy-MM-dd"),
            time: newTimeSlot+':00',
            category: 'public',
            available: true,
            newTimeSlot:true
          };
          const duplicate = [...avilableSlots, ...timeSlots].some(x => x.date === newSlot.date && x.time === newSlot.time);
          if(duplicate){
            toast.warning('datum och tid finns redan tillgängligt för bokning,justera tid eller datum');
          }else{
            setTimeSlots(prev => [...prev, newSlot]);
            setNewTimeSlot("");
          }
          
        }
      };
      // mappa bara till detta när request går iväg 
      /*
      const wtf = newSlots.map(x => {
    const buff = {date:x.date,startTime:x.time};
    return buff;
   })
      */
      const formatDateKey = (date: Date) => format(date, "yyyy-MM-dd");
       const selectedDateKey = selectedDate ? formatDateKey(selectedDate) : "";
       const selectedDateSlots = timeSlots.filter(slot => slot.date === selectedDateKey);
       const sendRebook = async () => {
        await DataService.BookingService.SendRebookProposal(selectedBooking.id,timeSlots);
       }
    return(
       <Modal onClose={()=> handleModal('reschedule')}>
        <div style={{ cursor: 'pointer', width: 35 }} onClick={() => handleModal('reschedule')}>
                        <AdminIcon.CrossClose fill='hsl(var(--primary))' />
                    </div>
          <label>
           Skapa unika lediga tider för denna ombokning. Tiderna du skapar får inte överlappa med tider som redan är skapade.
          </label>
          <div style={{width:'50%',display:'flex',flexDirection:'column',flexWrap:'wrap',gap:5,justifyContent:'center',alignItems:'flex-start',margin:8}}>
            <label htmlFor="date" className="card-managedates-date-label">Välj datum</label>
<input
  id="date"
  type="date"
  min={new Date().toISOString().split("T")[0]}
  value={selectedDate?.toISOString().split("T")[0] || ""}
  onChange={(e) => setSelectedDate(new Date(e.target.value))}
  className="card-managedates-date-inputfield"
/>
           {selectedDateSlots.length > 0 ? (
                 <ul className="card-managedates-createddates-stack">
                   {selectedDateSlots.map((slot) => (
                     <li key={slot.id} className="card-managedates-createddates-item">
                       <span className="card-managedates-createddates-item-time-label">{slot.time}</span>
                       <button
                         type="button"
                         onClick={() =>{
                          setTimeSlots(timeSlots.filter(be => be.id !== slot.id));
                         }}
                         className="delete-timeslot-button"
                       >
                         <AdminIcon.Trashcan width={20} height={20}/>
                       </button>
                     </li>
                   ))}
                 </ul>
               ) : (
                 <p className="card-managedates-createddates-no-timeslots">Inga föreslagna tider</p>
               )}
           
                <div className="card-managedates-add-time-stack">
                <label htmlFor="time" className="card-managedates-add-time-input-label">Lägg till tid</label>
                <div className="card-managedates-add-time-input-container">
                  <input
                    id="time"
                    type="time"
                    value={newTimeSlot}
                    onChange={(e) => setNewTimeSlot(e.target.value)}
                    className="card-managedates-add-time-input"
                  />
                  <button
                    type="button"
                    onClick={addTimeSlots}
                    className="card-add-time-button"
                  >
                    <AdminIcon.PlusSign width={15} height={15}/>
                  </button>
                </div>
              {/*Save time slots*/}
              </div>
              </div>
              <div style={{justifyContent:'flex-start'}}>   
                                  <button type="submit" className="sheet-form-submit-button" onClick={sendRebook}>
                                      <AdminIcon.Mail width={20} height={20} fill="white" />
                                      Skicka förfrågan
                                  </button>
                                  </div>
        </Modal> 
    )
}
